import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	tableData: {},
	formData: {},
	vendorPayment: {}, // show rates
	dataForServer: {}, // variable to update or create new
	tableRefresh: '',
	tableLoading: true,
	message: '',
	exportLoader: false,
	interpreterReplacedMessage: '',
	interpreterNotAvailableMessage: '',
	remarksData: {},
	patientColumName: '',
	originalFiles: {},
	completedFiles: {},
}

const getters = {
	getoriginalFiles(state, { formData }) {
		return state.originalFiles
	},
	getFormData(state, { formData }) {
		return state.formData
	},

	getStatus(state) {
		if (!_.isEmpty(state.formData)) {
			var status = state.formData[0].status_name
			var s = _.lowerCase(status) + '-bg';
			sessionStorage.setItem("statusClass", s);
			return s
		} else {
			sessionStorage.setItem("statusClass", '');
			return ''
		}
	},

	getShowCancelNotes(state) {
		//console.log(!_.isEmpty(state.formData[0]));
		if (!_.isEmpty(state.formData[0])) {
			if (state.formData[0].request_status_id == 2) {
				sessionStorage.setItem("showNotes", 'false');
				return false
			} else if (!_.isEmpty(state.remarksData)) {
				if (state.remarksData.remark_type_id == 2) {
					sessionStorage.setItem("showNotes", 'true');
					return true
				} else if (state.remarksData.remark_type_id == null) {
					if (!_.isEmpty(state.formData[0])) {
						if (state.formData[0].request_status_id == 4) {
							sessionStorage.setItem("showNotes", 'true');
							return true
						} else {
							sessionStorage.setItem("showNotes", 'false');
							return false
						}
					}
				}
			}
			sessionStorage.setItem("showNotes", 'false');
			return false
		} else {
			sessionStorage.setItem("showNotes", 'false');
			return false
		}
	},

	// only show cancel request textarea for scheduled, unassigned and in progress
	// do not show cancel for service date and time already passed
	getShowCancelRequest(state) {
		if (!_.isEmpty(state.formData)) {
			if (state.formData[0].show_cancel == 1) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	},

	getShowInfo(state) {
		if (!_.isEmpty(state.formData)) {
			return true
		} else {
			return false
		}
	},

	/**
	 * Process cancellation notes
	 */
	getNotes(state) {
		if (!_.isEmpty(state.remarksData)) {
			if (state.remarksData.remark_type_id == 2 && state.remarksData.cancel_type_id == 8) {
				var notes = "Cancelled by " + state.remarksData.cancel_name + " on " + state.remarksData.cancel_date + " at " + state.remarksData.cancel_time + ": " + state.remarksData.remark_notes;

				sessionStorage.setItem("NOTES", state.remarksData.remark_notes);
				return notes;
				// if not remark=job cancelled, check request_status_id
			} else if (state.remarksData.remark_type_id == null) {
				if (!_.isEmpty(state.formData[0])) {
					if (state.formData[0].request_status_id == 4) {
						var notes = "Cancelled by " + state.formData[0].updated_by + " (Excel) on " + state.formData[0].updated_date + " at " + state.formData[0].updated_time;
						return notes
					} else {
						return '';
					}
				}
			} else {
				var notes = "Cancelled by " + state.remarksData.cancel_name + " (Excel) on " + state.remarksData.cancel_date + " at " + state.remarksData.cancel_time;
				sessionStorage.setItem("NOTES", state.remarksData.remark_notes);
				return notes;
			}
		} else {
			return '';
		}
	},

	/**
	 * Switch Patient Name/Case Name column depending type of client
	 */
	getClientType(rootState) {
		var clientType = VueStore.state.user.user.client_type_id;
		return clientType;
	},

	/**
	 * Get job type
	 */
	getJobType(state) {
		if (!_.isEmpty(state.formData)) {
			var jobTypeId = state.formData[0].job_type_id;
			return jobTypeId;
		}
	}
}


// mutations
const mutations = {
	SET_TABLE_DATA(state, tableData) {
		state.tableData = tableData
	},

	SET_FORM_DATA(state, { formData }) {
		state.formData = formData
	},

	SET_VENDOR_PAYMENT_DATA(state, { vendorPaymentData }) {
		state.vendorPayment = vendorPaymentData
	},

	SET_DATA_FOR_UPDATE(state, { selectedData }) {
		state.dataForServer = selectedData
	},

	UPDATE_SELECTED_DATA(state, { key, value }) {
		// append/update dataForServer
		state.dataForServer[key] = value;

		// need to set formatData
		state.formData[key] = value;
	},

	SET_TABLE_REFRESH(state, table) {
		state.tableRefresh = table
	},

	SET_TABLE_LOADING(state, bool) {
		state.tableLoading = bool
	},

	// SET_MESSAGE (state, message){
	// 	state.message = message
	// },

	SET_MESSAGE(state, { key, message }) {
		eval('state.' + key + ' = message');
	},

	SET_EXPORT_LOADER(state, bool) {
		state.exportLoader = bool
	},

	SET_REMARKS_DATA(state, { remarksData }) {
		state.remarksData = remarksData
	},

	SET_PATIENT_COLUMN_NAME(state, rootState) {
		//console.log('Patient')
		var clientType = VueStore.state.user.user.client_type_id;
		var columnName = "Client Name";
		switch (clientType) {
			// Medical client
			case 1:
				state.patientColumName = columnName;
				break;
			// Education client
			case 2:
				columnName = 'Client Name';
				state.patientColumName = columnName;
				break;
		}
	},

	SET_VARIABLE(state, { key, value }) {
		eval('state.' + key + ' = value');
	},

	// APPEND_UPLOADED_FILE(state, {key, value}){
	// 	eval('state.'+key+'.push(value)');
	// },

	//state.dataForServer[key] = value;
	INSERT_INTO_ORIGINAL_FILES(state, { key, value }) {
		var oFiles = JSON.parse(JSON.stringify(state.originalFiles));
		var cfile = [];
		var nArray = {};
		var complete = [];

		for (var i = 0; i < oFiles.length; i++) {
			cfile = value.filter(item => item.translation_original_file_id == oFiles[i].id);
			nArray = {
				completedFiles: cfile
			};
			Object.assign(nArray, oFiles[i]);
			complete.push(nArray);
		}

		//console.log("complete", complete)
		state.originalFiles = {};
		state.originalFiles = complete;

		//console.log("state.originalFiles", state.originalFiles)
	}

}

// actions
const actions = {
	insertIntoOriginalFiles({ commit }, { key, value }) {
		commit('INSERT_INTO_ORIGINAL_FILES', { key: key, value: value });
	},
	setVariable({ commit }, { key, value }) {
		commit('SET_VARIABLE', { key: key, value: value });
	},
	// DT Compontent
	setTableData({ commit }, data) {
		commit('SET_TABLE_DATA', data);
	},

	// DT Compontent
	setFormData({ commit, state, dispatch, rootState }, data) {
		// console.log("setFormData", data)
		// revert back to option button
		VueStore.dispatch('nav/setVariables', 
				{
						key: 'activeInfoButton',
						value: 'options'
				}
		)
		var sData = state.tableData;
		var result = sData.filter(item => item.request_id == data.request_id);
		var jobType = data.job_type_id;

		var currentTab = sessionStorage.getItem("ACTIVE-REQUESTS-INFO-TAB");

		if (jobType == 2 && currentTab == 'files') {
			VueStore.dispatch('nav/setVariables', 
					{
							key: 'activeRequestInfoTab',
							value: 'files'
					}
			)
		} else if (currentTab == 'vos') {
			VueStore.dispatch('nav/setVariables', 
					{
							key: 'activeRequestInfoTab',
							value: 'vos'
					}
			)
		} else {
			VueStore.dispatch('nav/setVariables', 
					{
							key: 'activeRequestInfoTab',
							value: 'details'
					}
			)
		}

		// set formData here
		commit('SET_FORM_DATA', { formData: result });

		// copy this to request-vos store
		dispatch('requestVos/setVariable', { key: 'digitalFormData', value: result[0] }, { root: true })

		VueStore.dispatch('nav/setVariables', 
				{
						key: 'activeInfoDisplay',
						value: result[0].job_no
				}
		)

		var currentData = result[0];  // we'll use this to check for changes in status

		// need to point to client-requests endpoint to get grouped requests by client_request_id
		var url = rootState.auth.l + 'v1/client-requests';
		var include = '';

		// get documents if job type is translation.
		if (jobType == 2) {
			include = 'translation_original_files,translation_completed_files'
		}

		// var currentStatus = currentData.request_status_id;
		// var currentVendorId = currentData.vendor_id;

		var getData = {
			id: currentData.client_request_id,
			include: include
		}

		// get remarks belonging to request.
		dispatch('getRemarks', currentData.client_request_id);

		// get files
		VueStore.dispatch('requestFiles/getFiles');
		VueStore.dispatch('requestVos/getFiles');

		// call api to retrieve requests
		//console.log(currentData);
		$.ajax({
			url: url,
			data: getData,
			type: 'GET',
			beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a); },
			success: function (response) {
				if (jobType == 2) {
					if (typeof response.data[0].translation_original_files.data !== 'undefined') {
						var originalFiles = response.data[0].translation_original_files.data;
						commit('SET_VARIABLE', { key: 'originalFiles', value: originalFiles });
					}
					if (typeof response.data[0].translation_completed_files.data !== 'undefined') {
						var completedFiles = response.data[0].translation_completed_files.data;
						commit('SET_VARIABLE', { key: 'completedFiles', value: completedFiles });
						commit('INSERT_INTO_ORIGINAL_FILES', { key: 'completedFiles', value: completedFiles });
					}
				}
				// make sure vendor_payment is defined		
				if (typeof response.data[0].vendor_payment.data.length > 0) {
					var vendor_payment = response.data[0].vendor_payment.data[0].payment_details.data;
					commit('SET_VENDOR_PAYMENT_DATA', { vendorPaymentData: vendor_payment });
				}
			},
			error: function (xhr, ajaxOptions, error) {
				dispatch('auth/checkErrorAjax', xhr, { root: true })
			}
		});


		var selectedData = {
			id: data.id
		}

		//console.log(selectedData);
		commit('SET_DATA_FOR_UPDATE', { selectedData });
		//commit('SET_FORM_DATA', {formData: result[0]});
	},

	setFormWithNewData({ commit }, newData) {
		commit('SET_FORM_DATA', { formData: newData });
	},

	setTableRefresh({ commit }, table) {
		commit('SET_TABLE_REFRESH', table)
	},

	setTableLoading({ commit }, bool) {
		commit('SET_TABLE_LOADING', bool)
	},

	setExportLoader({ commit }, bool) {
		commit('SET_EXPORT_LOADER', bool)
	},

	updateSelectedData({ commit, state, dispatch }, key, value) {
		commit('UPDATE_SELECTED_DATA', key, value)
	},

	// Save data to server
	update({ commit, dispatch, state, getters, rootState, rootGetters }) {
		var header = rootState.auth.header;
		var data_id = state.dataForServer.id;
		var refreshTable = rootState.manage.tableRefresh;
		var table = `#${refreshTable}`;

		// If data_id exist, update existing location
		if (typeof data_id !== 'undefined') {
			var saveData = state.dataForServer;
			var url = rootState.auth.l + 'v1/client-requests/' + data_id;
			axios.put(url, saveData, header)
				.then(response => {
					// disable save loader
					dispatch('manage/setSaveLoader', false, { root: true });
					//console.log(response);

					// reload datatable
					$(table).DataTable().ajax.reload();
				}).catch((error) => {
					console.log(error);
				});
			// Create new location
		} else {
			dispatch('create');
		}
	},

	// Create new record
	create({ commit, state, dispatch, getters, rootState, rootGetters }) {
		var header = rootState.auth.header;
		var saveData = state.dataForServer;
		var url = rootState.auth.l + 'v1/client-requests';
		//var refreshTable = rootState.manage.tableRefresh;
		var table = `#${refreshTable}`;

		axios.post(url, saveData, header)
			.then(response => {
				// disable save loader
				dispatch('manage/setSaveLoader', false, { root: true });
				//console.log(response);

				// set form data
				commit('SET_FORM_DATA', { formData: response.data.data });
				// set server data
				commit('SET_DATA_FOR_UPDATE', { selectedData: response.data.data });
				//console.log(response.data);

				// show delete and cancel button
				dispatch('manage/setShowButton', true, { root: true });

				// reload datatable
				$(table).DataTable().ajax.reload();
			}).catch((error) => {
				console.log(error);
			});
	},

	// delete record
	delete({ commit, state, dispatch, getters, rootState, rootGetters }) {
		var header = rootState.auth.header;
		var data_id = state.dataForServer.id;
		var refreshTable = rootState.manage.tableRefresh;
		var table = `#${refreshTable}`;

		// If data_id exist, update existing location
		if (typeof data_id !== 'undefined') {
			var saveData = state.dataForServer;
			var url = rootState.auth.l + 'v1/client-requests/' + data_id + '/delete';
			axios.post(url, saveData, header)
				.then(response => {
					// disable save loader
					dispatch('manage/setCanSave', false, { root: true });
					// disable delete and cancel button
					dispatch('manage/setShowButton', false, { root: true });

					// dispatch clear to remove the data in vuex
					dispatch('clear');
					// reload datatable
					$(table).DataTable().ajax.reload();
				}).catch((error) => {
					console.log(error);
				});
			// Create new location
		} else {
			console.log("Cannot delete.");
		}
	},

	// delete record
	clear({ commit, state, dispatch, getters, rootState, rootGetters }) {
		var empty = {};
		commit('SET_DATA_FOR_UPDATE', { selectedData: empty });
		commit('SET_FORM_DATA', { formData: empty });
		dispatch('manage/setShowButton', false, { root: true });
		dispatch('manage/setCanSave', false, { root: true });
	},

	autoSelectRow({ commit, state, rootState, dispatch }, row) {

		var refreshTable = rootState.requests.tableRefresh;
		var table = `#${refreshTable}`;
		var trid;

		if (typeof row !== 'undefined') {
			trid = row.request_id;
			//console.log(trid);
			setTimeout(function () { $(table + ' tr#' + trid).addClass('selected'); }, 500);
			dispatch('setFormData', row);
			dispatch('resetScrollPos');
		}
	},

	selectFirstRow({ commit, state, rootState }) {
		var refreshTable = rootState.requests.tableRefresh;

		if (typeof refreshTable !== 'undefined') {
			var table = `#${refreshTable}`;
			setTimeout(function () { $(table + ' tbody tr:nth-child(1)').click(); }, 500);
		}
	},

	// reselect user's selected row on a reload.
	userSelectRow({ commit, state, dispatch }) {
		var savedTRID = sessionStorage.getItem('TRID');
		var trid = savedTRID;

		$('tr#' + trid).addClass('selected');
		dispatch('resetScrollPos');
	},

	resetScrollPos(state) {
		// reset the scroll position
		var scrollPos = sessionStorage.getItem('SCROLL-POS') === null ? 0 : Number(sessionStorage.getItem('SCROLL-POS'));
		//console.log(scrollPos);
		$('div.dataTables_scrollBody').scrollTop(Number(scrollPos));
		// setTimeout(function(){
		// 	$('div.dataTables_scrollBody').scrollTop(Number(scrollPos));
		// }, 500);
	},

	// this is called from cancelRequest store after successfuly cancellation
	setFormDataAfterCancel({ commit, state, dispatch, rootState }, client_request_id) {
		var getData = {
			id: client_request_id
		}

		var url = rootState.auth.l + 'v1/client-requests';
		$.ajax({
			url: url,
			data: getData,
			type: 'GET',
			beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a); },
			success: function (response) {
				//new data will be 
				//data[0].requests.data[0..1..3]

				var newData = response.data[0].requests.data;
				commit('SET_FORM_DATA', { formData: newData });
			},
			error: function (xhr, ajaxOptions, error) {
				dispatch('auth/checkErrorAjax', xhr, { root: true })
			}
		});
	},

	/**
	 * Get remarks
	 * Only retrieve remarks with cancellation_type = 8 (8 = Client Portal)
	 */
	getRemarks({ commit, dispatch, state, getters, rootState, rootGetters }, id) {
		var header = rootState.auth.header;
		var url = rootState.auth.l + 'v1/request-remarks';

		var dataForServer = {
			client_request_id: id,
			remark_type_id: 2,
			//cancel_type_id: 8
		};

		$.ajax({
			url: url,
			data: dataForServer,
			type: 'GET',
			beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a); },
			success: function (response) {
				//console.log(response.data[0]);
				//check to see if there's a remarks for this job
				if (typeof (response.data[0]) !== 'undefined') {
					commit('SET_REMARKS_DATA', { remarksData: response.data[0] });
				} else {
					//pass in empy values or null since no remarks exist
					var remarksData = {
						'remark_notes': '',
						'remark_type_id': null,
						'cancel_type_id': null,
					}
					commit('SET_REMARKS_DATA', { remarksData: remarksData });
				}
			},
			error: function (xhr, ajaxOptions, error) {
				console.log(xhr);
			}
		});

		/*		var url = rootState.auth.l+'v1/request-remarks';
				axios.get(url,data,header)
				.then(response => {
					console.log("remarks:");
					console.log(response.data.data);
				}).catch((error) => {
					console.log(error);
				});
		*/
	},

	setPatientColumn({ commit }) {
		commit('SET_PATIENT_COLUMN_NAME');
	}

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}